import { render, staticRenderFns } from "./FormGrid.vue?vue&type=template&id=8a2c685c&scoped=true&"
import script from "./FormGrid.vue?vue&type=script&lang=js&"
export * from "./FormGrid.vue?vue&type=script&lang=js&"
import style0 from "./FormGrid.vue?vue&type=style&index=0&id=8a2c685c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2c685c",
  null
  
)

export default component.exports